export default "__VITE_ASSET__BNrMWFug__"